export enum UIComponents {
    Balance = "balance_amount",
    Win = "win_amount",
    TotalWin = "total_win_amount",
    TotalBet = "bet_amount",
    AutoCounter = "auto_counter",
    AutoCounterBg = "new_autotab",
    TotalWinLabel = "total_win",
    TotalWinAmount = "total_win_amount",
    BetInfoGroup = "bet_info",
    FreeGamesInfoGroup = "free_games_info",
    FreeGames = "freeGames_amount",
    FreeSpinsInfoGroup = "free_spins_info",
    FreeSpins = "freeSpins_amount",
}
